// Lib
import { classicFormat } from '@/utils/hooks/format/useFormatNumber';

import { SIZE_50 } from '@/lib/gridElements/size';
import { INSTAGRAM } from '@/lib/socialProfile';

// Components
import { SingleIconPieChart } from '@/components/composite/Charts/SingleIconPieChart';

export const mentionsByPost = {
    title: 'chart.instagram.mentions_by_post',
    id: 'mentions_distribution_per_post',
    icon: 'comments-on',
    name: {
        photo: 'chart.post_type_instagram.photo',
        video: 'chart.post_type_instagram.video',
        carousel: 'chart.post_type_instagram.carousel',
        reel: 'chart.post_type_instagram.reel',
        type: 'type',
        value: 'count',
        percentage_formatted: 'percentage'
    },
    color: {
        photo: 'blue',
        video: 'purple',
        carousel: 'aquablue',
        reel: 'red'
    },
    social: INSTAGRAM,
    tooltipTranslation: {
        token: 'chart.facebook.views_distribution_source_tooltip_translation',
        values: ['name', 'value', 'percentage']
    },
    tableColumnFormatterTranslation: 'analytics:chart.instagram.percentage_post',
    valueFormat: classicFormat,
    tooltip: 'chart.instagram.mentions_by_post_tooltip',
    size: SIZE_50,
    type: 'chart',
    element: SingleIconPieChart
};
